import { useEffect } from "react";
import { toast } from "react-toastify";
import { useFetch } from "utils/hooks";

import { useQuery } from "@tanstack/react-query";

import { ExtendedCacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { Hall } from "./type.ts";

const useHalls = () => {
  const fetch = useFetch();

  const { data, isFetching, isError } = useQuery<
    {
      halls: Hall[];
    } | null,
    Error,
    Hall[]
  >({
    queryKey: ["halls"],
    select: (res) =>
      res?.halls.map((el) => {
        return {
          ...el,
          information: el.information,
        } as Hall;
      }) || [],
    queryFn: () =>
      fetch<{
        halls: Hall[];
      }>(Urls.Halls, {
        method: "GET",
      }),
    gcTime: ExtendedCacheTime,
    staleTime: ExtendedCacheTime,
  });

  useEffect(() => {
    if (isError) {
      toast.error("Error getting halls");
    }
  }, [isError]);

  return {
    halls: data,
    isFetching,
  };
};

export default useHalls;
